<script>
import GlobalSeacrhPanel from '@/components/global-search/GlobalSeacrhPanel.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';
import MainConainer from '@/components/container/MainContainer.vue';
import ProviderList from '@/components/page-main/ProviderList.vue';

import ButtonFilter from '@/components/left-panel/unique-buttons/ButtonFilter.vue';
import ButtonTag from '@/components/left-panel/unique-buttons/ButtonTag.vue';
import ButtonAssetType from '@/components/left-panel/unique-buttons/ButtonAssetType.vue';
import ButtonProviderAndGame from '@/components/left-panel/unique-buttons/ButtonProviderAndGame.vue';
import ButtonGupUploads from '@/components/left-panel/unique-buttons/ButtonGupUploads.vue';
import ButtonSmartFilter from '@/components/left-panel/unique-buttons/ButtonSmartFilter.vue';
import ButtonChatGPT from '@/components/left-panel/unique-buttons/ButtonChatGPT.vue';
import ButtonUserAndRole from '@/components/left-panel/unique-buttons/ButtonUserAndRole.vue';
import ButtonGlobalSearch from '@/components/left-panel/file-button/ButtonGlobalSearch.vue';
import ToggleButton from '@/components/left-panel/any-button/ToggleButton.vue';
import ButtonChangeLog from '@/components/left-panel/unique-buttons/ButtonChangeLog.vue';
import ButtonTestEmails from '@/components/left-panel/unique-buttons/ButtonTestEmails.vue';
import ButtonAntifraud from '@/components/left-panel/unique-buttons/ButtonAntifraud.vue';
import ButtonBilling from '@/components/left-panel/unique-buttons/ButtonBilling.vue';
import ButtonCorporateRequests from '@/components/left-panel/unique-buttons/ButtonCorporateRequests.vue';
import ButtonPublisherRequests from '@/components/left-panel/unique-buttons/ButtonPublisherRequests.vue';
import ButtonPublishers from '@/components/left-panel/unique-buttons/ButtonPublishers.vue';
import ButtonPartners from '@/components/left-panel/unique-buttons/ButtonPartners.vue';
import ButtonUserAnalytics from '@/components/left-panel/unique-buttons/ButtonUserAnalytics.vue';
import ButtonSystemAnalytics from '@/components/left-panel/unique-buttons/ButtonSystemAnalytics.vue';
import SidebarSection from '@/components/container/SidebarSection.vue';

import { calculatePromise, promiseAll } from '@/api/default.js';
import autoRefreshMixin from '@/mixins/autoRefreshMixin.js';
import constants from '@/constants';

export default {
    mixins: [autoRefreshMixin],
    components: {
        GlobalSeacrhPanel: GlobalSeacrhPanel,

        LeftPanel: LeftPanel,
        RightContainer: RightContainer,
        MainConainer: MainConainer,
        ProviderList: ProviderList,

        ButtonFilter: ButtonFilter,
        ButtonTag: ButtonTag,
        ButtonAssetType: ButtonAssetType,
        ButtonProviderAndGame: ButtonProviderAndGame,
        ButtonGupUploads: ButtonGupUploads,
        ButtonSmartFilter: ButtonSmartFilter,
        ButtonChatGPT: ButtonChatGPT,
        ButtonUserAndRole: ButtonUserAndRole,
        ButtonGlobalSearch: ButtonGlobalSearch,
        ButtonChangeLog: ButtonChangeLog,
        ButtonTestEmails: ButtonTestEmails,
        ButtonAntifraud: ButtonAntifraud,
        ButtonBilling: ButtonBilling,
        ButtonCorporateRequests: ButtonCorporateRequests,
            ButtonPublisherRequests: ButtonPublisherRequests,
            ButtonPublishers: ButtonPublishers,
            ButtonPartners: ButtonPartners,
        ButtonUserAnalytics: ButtonUserAnalytics,
        ButtonSystemAnalytics: ButtonSystemAnalytics,

        ToggleButton: ToggleButton,
        SidebarSection: SidebarSection,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);
        const promiseList = await calculatePromise([
            {
                dispatch: 'CHECK_PROVIDERS_AND_GAMES_AXIOS',
                commit: 'PROVIDERS_AND_GAMES',
                isArray: false,
            },
            { dispatch: 'CHECK_GAMES_AXIOS', commit: 'GAMES', isArray: false },
            {
                dispatch: 'CHECK_PROVIDER_AXIOS',
                commit: 'PROVIDERS',
                isArray: false,
            },
        ]);
        await promiseAll(promiseList);

        // Load email mode to determine if test emails should be shown
        // Load email mode to determine if test emails should be shown
        await this.$store.dispatch('LOAD_EMAIL_MODE');

        // Load pending corporate requests count
        await this.$store.dispatch('loadPendingCount');
        await this.$store.dispatch('loadDisputesCount');

        this.$store.commit('IS_LOAD', false);

        // One timer: the mixin keeps a single interval, a second start
        // would cancel the first.
        this.startAutoRefresh(
            'loadSidebarCounts',
            constants.AUTO_REFRESH_INTERVALS.PENDING_COUNT
        );
    },
    computed: {
        showNewGame() {
            return this.$store.getters.IS_SHOW_NEW_PROVIDER_AND_GAMES;
        },
        searchActive() {
            return this.sidebarQuery ? this.sidebarQuery.trim().length > 0 : false;
        },
    },
    data() {
        return {
            sidebarQuery: '',
        };
    },
    methods: {
        matchesSearch(label) {
            if (!this.sidebarQuery || !this.sidebarQuery.trim()) return true;
            return label.toLowerCase().includes(this.sidebarQuery.trim().toLowerCase());
        },
        async toggleShowNewGame() {
            this.$store.commit(
                'IS_SHOW_NEW_PROVIDER_AND_GAMES',
                !this.showNewGame
            );
            this.filters = await this.$store.dispatch(
                'UPDATE_PROVIDER_AND_GAMES'
            );
        },
    },
};
</script>

<template>
    <GlobalSeacrhPanel />
    <MainConainer>
        <LeftPanel v-model:query="sidebarQuery">
            <SidebarSection title="Main Page" :default-open="true" :force-open="searchActive">
                <ButtonFilter v-show="matchesSearch('Filter')" />
                <ButtonTag v-show="matchesSearch('Tags')" />
                <ButtonProviderAndGame v-show="matchesSearch('Providers & Games')" />
                <ButtonGupUploads v-show="matchesSearch('GUP uploads')" />
                <ButtonSmartFilter v-show="matchesSearch('Smart Filter')" />
                <ButtonAssetType v-show="matchesSearch('Assets Types')" />
                <ButtonChatGPT v-show="matchesSearch('Setting ChatGPT')" />
                <ButtonUserAndRole v-show="matchesSearch('User & Role')" />
            </SidebarSection>
            <SidebarSection title="Info Page" :force-open="searchActive">
                <ButtonChangeLog v-show="matchesSearch('Changelog')" />
                <ButtonTestEmails v-show="matchesSearch('Test Emails')" />
                <ButtonAntifraud v-show="matchesSearch('Antifraud')" />
                <ButtonBilling v-show="matchesSearch('Billing')" />
                <ButtonCorporateRequests v-show="matchesSearch('Corporate Requests')" />
                <ButtonPublisherRequests v-show="matchesSearch('Publisher Requests')" />
                <ButtonPublishers v-show="matchesSearch('Providers')" />
                <ButtonPartners v-show="matchesSearch('Partners')" />
                <ButtonUserAnalytics v-show="matchesSearch('User Analytics')" />
                <ButtonSystemAnalytics v-show="matchesSearch('System Analytics')" />
            </SidebarSection>
            <SidebarSection title="Search Tools" :force-open="searchActive">
                <ButtonGlobalSearch v-show="matchesSearch('Global Search')" />
                <ToggleButton
                    v-show="matchesSearch('Show New Game')"
                    title="Show New Game"
                    :toggle="showNewGame"
                    :method="toggleShowNewGame"
                />
            </SidebarSection>
        </LeftPanel>
        <RightContainer>
            <ProviderList />
        </RightContainer>
    </MainConainer>
</template>
